import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=90304d18&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=90304d18&prod&lang=scss"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=90304d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90304d18",
  null
  
)

export default component.exports